import { render, staticRenderFns } from "./MySoftwareDetail.vue?vue&type=template&id=23991998&scoped=true&"
import script from "./MySoftwareDetail.vue?vue&type=script&lang=js&"
export * from "./MySoftwareDetail.vue?vue&type=script&lang=js&"
import style0 from "./MySoftwareDetail.vue?vue&type=style&index=0&id=23991998&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23991998",
  null
  
)

export default component.exports